import { FC } from 'react'

import {
  Text,
  GreyGrey100,
  Primary13SemiBold,
  TextAreaFieldInput,
  Flex
} from '@sequencehq/core-components'

export const ChangelogField: FC<{
  changelog: string
  setChangelog: (next: string) => void
}> = ({ changelog, setChangelog }) => {
  return (
    <Flex flexDir="column" gap="8px" data-testid="automations.editor.changelog">
      <Text {...Primary13SemiBold} color={GreyGrey100}>
        What's changed
      </Text>

      <TextAreaFieldInput
        value={changelog}
        onChange={e => setChangelog(e.target.value)}
        placeholder="Optional message..."
        data-testid="automations.editor.changelog.input"
      />
    </Flex>
  )
}
